import React,{useState,useEffect} from 'react'
import { StateUseContext } from '../../context/UserDetailContext';
import { upadateProfileDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';
import { getAreas, getEmirates, getSubAreas } from '../../actions/RegisterAction';




const AddressInfo = ({nexTabChange}) => {
    const {userDetail, setUserDetail} = StateUseContext();

    const [address1, setAddress1] = useState({ value: '', error: '' });
    const [address2, setAddress2] = useState({ value: '', error: '' });
    const [area, setArea] = useState({ value: '', error: '' });
    const [pincode, setPincode] = useState({ value: '', error: '' });
    const [landmark, setLandmark] = useState({ value: '', error: '' });

    const [UserEmirate, setUserEmirate] = useState({value:'', options:[], error:''});
    const [UserArea, setUserArea] = useState({value:'', options:[], error:''});
    const [UserSubArea, setUserSubArea] = useState({value:'', options:[], error:''});

    const [loading, setLoading] = useState(false);

    // First useEffect - handle form field updates
    useEffect(() => {
        if (userDetail) {
            setArea(prev => ({ ...prev, value: userDetail.area || '' }));
            setAddress1(prev => ({ ...prev, value: userDetail.address1 || '' }));
            setAddress2(prev => ({ ...prev, value: userDetail.address2 || '' }));
            setPincode(prev => ({ ...prev, value: userDetail.zip_code || '' }));
            setLandmark(prev => ({ ...prev, value: userDetail.landmark || '' }));
        }
    }, [userDetail]);

    // Second useEffect - handle Emirates data fetching
    useEffect(() => {
        const getEmiratesData = async () => {
            try {
                if (!userDetail?.country_id) return;
                
                const response = await getEmirates(userDetail.country_id);
                setUserEmirate(prev => ({...prev, options: response?.data,value:userDetail.emirate_id}));
            } catch (error) {
                console.error('Error fetching emirates:', error);
            }
        };
        const getAreasData = async () => {
            try {
                if (!userDetail?.country_id) return;
                
                const response = await getAreas(userDetail.emirate_id);
                setUserArea(prev => ({...prev, options: response?.data,value:userDetail.area_id}));
            } catch (error) {
                console.error('Error fetching emirates:', error);
            }
        };
        const getSubAreasData = async () => {
            try {
                if (!userDetail?.country_id) return;
                
                const response = await getSubAreas(userDetail.area_id);
                setUserSubArea(prev => ({...prev, options: response?.data,value:userDetail.sub_area_id}));
            } catch (error) {
                console.error('Error fetching emirates:', error);
            }
        };
        getAreasData()
        getSubAreasData()
        getEmiratesData();
    }, [userDetail]); 

    const changeEmirateHandler = async (e) => {
        setUserEmirate({...UserEmirate,value:e.target.value,error:''})
        setUserArea(prev => ({...prev, value:'',error:''}));
        setUserSubArea(prev => ({...prev, value:'',error:''}));

        const areasData = await getAreas(e.target.value);
        setUserArea(prev => ({...prev, options: areasData?.data}));
    }

    const changeAreaHandler = async (e) => {
        setUserArea({...UserArea,value:e.target.value,error:''});
        setUserSubArea(prev => ({...prev, value:'',error:''}));;

        const response = await getSubAreas(e.target.value);
        setUserSubArea(prev => ({...prev, options: response?.data}));
    }

    // Validation
    const validation = () => {
        let formIsValid = true
        //    Address 1
        if (!address1.value) {
            formIsValid = false
            let msg = "Please enter your Address"
            setAddress1({ ...address1, error: msg })
        }
        else if (address1.value.length <= 3) {
            formIsValid = false
            let msg = "Min 4 Digit Length"
            setAddress1({ ...address1, error: msg })
        }
        else if (address1.value.length >= 128) {
            formIsValid = false
            let msg = "Max 128 Digit Length"
            setAddress1({ ...address1, error: msg })
        }

        // Area
        // if (!area.value) {
        //     formIsValid = false
        //     let msg = "Please enter your area"
        //     setArea({ ...area, error: msg })
        // }
        if (!pincode.value) {
            formIsValid = false
            let msg = "Please enter your pincode"
            setPincode({...pincode,error:msg})  
        }

        if (!landmark.value) {
            formIsValid = false
            let msg = "Please enter landmark"
            setLandmark({...landmark,error:msg})  
        }


        if (!UserEmirate.value) {
            formIsValid = false
            let msg = "Please select emirate"
            setUserEmirate({ ...UserEmirate, error: msg })
        }

        if (UserArea?.options?.length > 0 && !UserArea.value) {
            formIsValid = false
            let msg = "Please select area"
            setUserArea({ ...UserArea, error: msg })
        }
        if (UserSubArea?.options?.length > 0 && !UserSubArea.value) {
            formIsValid = false
            let msg = "Please select sub area"
            setUserSubArea({ ...UserSubArea, error: msg })
        }

       
        if (formIsValid) {
            setAddress1({...address1, error : ''});
            // setArea({...area, error : ''});
            setLandmark({...landmark, error : ''});
            setPincode({...pincode, error : ''});
            setUserEmirate({ ...UserEmirate, error: '' })
            setUserArea({ ...UserArea, error: '' })
            setUserSubArea({ ...UserSubArea, error: '' })
        }

        return formIsValid;

    }


    const submitFormHandler = async(e) => {
        e.preventDefault();

        if(validation()){
            setLoading(true)
            const data = {
                id:userDetail?.id,
                address1:address1.value,
                address2:address2.value,
                // area:area.value,
                landmark:landmark.value,
                zip_code:pincode.value,
                sub_area:UserSubArea.value || null,
                emirate:UserEmirate.value || null,
                area_id:UserArea.value || null,
            }

            try {
                await upadateProfileDetail(data).then((res) => {
                    if(res.status){
                        setLoading(false)
                        setUserDetail({...userDetail,...res?.data})
                        swal(res?.message,'','success')
                    }
                    else{
                        setLoading(false)
                        swal(res?.message,'','error')
                    }
                })
            } catch (error) {
                console.log('update profile..',error)
            }
        }
    }

  return (
    <>
        <p className="text-info border-3 mt-2 mb-2 border-start ps-2 bg-light py-2 mb-4 border-info fw-semibold" style={{fontSize:'15px'}}>  
        <b>Note: </b><br></br> 1. Please provide complete Address for Study Material dispatch in <b className='text-primary'><u>{userDetail?.country_name}</u></b>  <br></br> 2. Study materials will not be dispatched to addresses within India.</p>

        <form onSubmit={submitFormHandler} >
            <div className="row">
                <div className="col-md-6 mb-3">
                        <label className="form-label">Emirate<span>*</span></label>
                        <select className="form-control" value={UserEmirate.value || ''} onChange={(e) => changeEmirateHandler(e)}>
                            <option value="">Select Emirate</option>
                            {UserEmirate?.options?.map(emirate => (
                                <option key={emirate.id} value={emirate.id}>{emirate.name}</option>
                            ))}
                        </select>
                        {UserEmirate?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{UserEmirate.error}</small>}
                </div>
                <div className="col-md-6 mb-3">
                    <div className="row gx-3">
                        {UserArea?.options?.length > 0 && (
                            <div className="col-md-6">
                                <label className="form-label">Area<span>*</span></label>
                                <select className="form-control" value={UserArea.value  || ''} onChange={e => changeAreaHandler(e)}>
                                    <option value="">Select Area</option>
                                    {UserArea?.options?.map(area => (
                                    <option key={area.id} value={area.id}>{area.name}</option>
                                    ))}
                                </select>
                                {UserArea?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{UserArea.error}</small>}   
                            </div>
                        )}
                        {UserSubArea?.options?.length > 0 && (
                        <div className="col-md-6">
                            <label className="form-label">Sub Area<span>*</span></label>
                            <select className="form-control" value={UserSubArea.value || ''} onChange={e => setUserSubArea({...UserSubArea,value:e.target.value,error:''})}>
                                <option value="">Select Sub Area</option>
                                {UserSubArea?.options?.map(subArea => (
                                <option key={subArea.id} value={subArea.id}>{subArea.name}</option>
                                ))}
                            </select>
                            {UserSubArea?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{UserSubArea.error}</small>}
                        </div>
                        )}
                    </div>  
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 mb-3">
                        <label  className="form-label">Address Line 1<span>*</span></label>
                        <input type="text"
                            className="form-control" placeholder="Enter Address 1"
                            value={address1.value !==null ? address1.value : ''}
                            onChange={(e) => setAddress1({ ...address1, value: e.target.value, error: '' })}
                        />
                        {address1.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{address1.error}</small>}
                </div>                   
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Address Line 2 (Optional)</label>
                    <input type="text"
                    className="form-control" placeholder="Enter Address 2 "
                    value={address2.value!==null?address2.value:''}
                    onChange={(e) => setAddress2({ ...address2, value: e.target.value, error: '' })} />
                    {address2.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{address2.error}</small>}

                </div>

                <div className="col-md-6 mb-3">
                    <div className="row gx-3">
                        <div className="col-lg-12">
                            <label className="form-label">Postal Zip Code<span>*</span></label>
                            <input type="text"
                            className="form-control"
                            placeholder="Enter Zip Code..."
                            value={pincode.value !==null ? pincode.value : ''}
                            onChange={(e) => setPincode({ ...pincode, value: e.target.value, error: '' })}
                        />
                        {pincode.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{pincode.error}</small>}

                        </div>

                        {/* <div className="col-lg-6 mt-3 mt-lg-0">
                            <label className="form-label">Area<span>*</span></label>
                            <input type="text"
                            className="form-control" placeholder="Enter Area..."
                            value={area.value!==null?area.value:''}
                            onChange={(e) => setArea({ ...area, value: e.target.value, error: '' })} />
                            {area.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{area.error}</small>}

                        </div> */}

                        
                    </div>
                </div>

                <div className="col-lg-6 mt-3 mt-lg-0">
                            <label className="form-label">Landmark<span>*</span></label>
                            <input type="text"
                            className="form-control" placeholder="Enter Landmark"
                            value={landmark.value!==null?landmark.value:''}
                            onChange={(e) => setLandmark({ ...landmark, value: e.target.value, error: '' })} />
                            {landmark.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{landmark.error}</small>}

                </div>
            </div>

            {/* <div className="col-md-12 mb-3">
                    <label className="form-label">Address<span>*</span></label>
                    <textarea rows={3} className='w-100 form-control' placeholder='Enter your building name, flat number, pin code/postal zip code ' value={UserAddress.value?.toLowerCase() ||''} onChange={e => setUserAddress({...UserAddress,value:e.target.value,error:''})}></textarea>
                    {UserAddress?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{UserAddress.error}</small>}
            </div> */}

            <div className="col-md-12 mt-2">
            {loading ? <button className="btn btn-default" disabled type="button">
                    <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                        Updating...</button>:<button type="submit" className="btn btn-default">Save</button>}
            {/* <button className="btn btn-default ms-2" onClick={e => nexTabChange()} type="button">Next</button> */}
            </div>
        </form>
    </>
  )
}

export default AddressInfo